import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator

export const statisticOverStart = () => {
    return {
        type: 'STATISTIC|STATISTIC_OVERVIEW_START',
        loading: true
    };
};
export const statisticOverSuccess = (data) => {
    return {
        type: 'STATISTIC|STATISTIC_OVERVIEW_SUCCESS',
        loading: false,
        data: data

    };
};
export const statisticOverFail = () => {
    return {
        type: 'STATISTIC|STATISTIC_OVERVIEW_FAIL',
        loading: false
    };
};


// custom functions
export const listStatisticOverview = (id) => {
    let token = localStorage.getItem('SESSION');

    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            dispatch(statisticOverStart())
            let res = await rest.post('/statistics/overview', { ...id, Token: token });
            if (res.data && res.data.succeeded) {
                dispatch(statisticOverSuccess(res.data.result.data))
                return res.data.result.data;
            }
            else {
                dispatch(statisticOverFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            dispatch(statisticOverFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            })
            return [];
        }
    };
}